import { NODES, ROLE_VIEWS } from "./data";
import { LocalBoundary } from "./ui";

const SECTIONS = [
    ["evidence", "Evidence held locally"],
    ["received", "Information received"],
    ["checks", "Checks performed"],
    ["permitted", "Permitted actions"],
];

export const RoleViewPanel = ({ view }) => {
    const rv = ROLE_VIEWS[view];
    const node = NODES.find((n) => n.id === view);
    if (!rv || !node) return null;

    return (
        <LocalBoundary testId={`role-view-panel-${view}`} highlight>
            <p className="text-sm font-medium text-slate-900">{node.name} — role view</p>
            <p className="mt-1 text-xs text-slate-500">{node.desc}</p>
            <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                {SECTIONS.map(([key, label]) => (
                    <div key={key}>
                        <p className="font-mono text-[10px] uppercase tracking-wide text-slate-400">{label}</p>
                        <ul className="mt-1 space-y-0.5 text-sm text-slate-600">
                            {rv[key].map((v) => <li key={v}>· {v}</li>)}
                        </ul>
                    </div>
                ))}
            </div>
            <div className="mt-4 grid gap-3 border-t border-slate-100 pt-3 sm:grid-cols-2">
                <div>
                    <p className="font-mono text-[10px] uppercase tracking-wide text-blue-900">Decision made</p>
                    <p className="mt-1 text-sm text-slate-700">{rv.decision}</p>
                </div>
                <div>
                    <p className="font-mono text-[10px] uppercase tracking-wide text-green-700">Receipt issued</p>
                    <p className="mt-1 text-sm text-slate-700">{rv.receipt}</p>
                </div>
            </div>
        </LocalBoundary>
    );
};
